import React, { useContext, useState } from 'react';
import classNames from 'classnames/bind';
import { IconAddInCircle32, StickerLabel, Text } from '@stitch-fix/mode-react';
import { NavContext } from '../../../../../NavContextWrapper';
import changeClient from '../../../../../../api/changeClient';
import { Client } from '../../../../../NavContextWrapper/types';
import styles from './style.module.scss';
import AccountBadge from '../../AccountBadge';
import { useHousehold } from '../../../helpers/useHousehold';
import AddProfileModal from './AddProfileModal';

interface HouseholdMembersProps {
  client: Client;
}

const cx = classNames.bind(styles);

const HouseholdMembers = ({ client }: HouseholdMembersProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { rootUrl } = useContext(NavContext);
  const { getCircleColorForUser, householdMembersBesidesSelf, canAddProfiles } =
    useHousehold(client);

  const handleChangeClient = (clientId: string, businessLine: string) => {
    changeClient(rootUrl, clientId).then(responseText => {
      if (responseText.auth_token) {
        // eslint-disable-next-line no-restricted-globals -- inside useEffect
        if (businessLine.toLowerCase() === 'kids') {
          // eslint-disable-next-line no-restricted-globals -- inside useEffect
          window.location.assign(`${rootUrl}/fix-home`);
        } else {
          // eslint-disable-next-line no-restricted-globals -- inside useEffect
          window.location.assign(`${rootUrl}/home`);
        }
      } else {
        throw Error(responseText.error);
      }
    });
  };

  return (
    <>
      <Text setting="eyebrow-small" ml={0.375} my={0.5}>
        Switch Profiles
      </Text>
      {householdMembersBesidesSelf.map(member => {
        return (
          <button
            key={member.id}
            data-ga="meganav-primary-dropdown-switch-account"
            className={cx('section-row', 'section-row-button')}
            onClick={() => handleChangeClient(member.id, member.businessLine)}
            type="button"
          >
            <div className={styles['section-row-icon']}>
              <AccountBadge
                circleColor={getCircleColorForUser(member)}
                text={member.firstName.charAt(0)}
              />
            </div>
            <Text height="standard" family="regular" scale="3">
              {member.firstName}
            </Text>
          </button>
        );
      })}
      {canAddProfiles && (
        <>
          <button
            className={cx('section-row', 'section-row-button')}
            data-ga="meganav-primary-dropdown-add-profile"
            onClick={() => setIsModalOpen(true)}
            type="button"
          >
            <div className={styles['section-row-icon']}>
              <IconAddInCircle32 purpose="decorative" />
            </div>
            Add a profile{' '}
            <StickerLabel ml={0.5} variant="citrus">
              New
            </StickerLabel>
          </button>
          <AddProfileModal
            isModalOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </>
      )}
    </>
  );
};

export default HouseholdMembers;
